import tailwindColors from './tailwindColors';

export const colors = {
  // Update me with other Tailwind colors or with https://uicolors.app
  codGray: tailwindColors.codGray,
  green: tailwindColors.success,
  red: tailwindColors.error,

  // Design System Colors (https://www.figma.com/design/XHzTETWWR6lg9UFoz7LWqw/SynapsAI.ai?node-id=2018-15450&node-type=FRAME&t=eybTuE3CrQT6iaGJ-0)
  gray: tailwindColors.brandGray,
  brand: tailwindColors.primary,
  primary: tailwindColors.primary,
  success: tailwindColors.success,
  info: tailwindColors.info,
  warning: tailwindColors.warning,
  error: tailwindColors.error,
};
